import { render, staticRenderFns } from "./BillingScopeDropdown.vue?vue&type=template&id=5a55de9c&scoped=true"
import script from "./BillingScopeDropdown.vue?vue&type=script&lang=js"
export * from "./BillingScopeDropdown.vue?vue&type=script&lang=js"
import style0 from "./BillingScopeDropdown.vue?vue&type=style&index=0&id=5a55de9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a55de9c",
  null
  
)

export default component.exports